import { el, list } from 'redom';

import Option from './option';

class RadioButtonGroupRenderer {

  constructor() {

    this.input = null;

    this.el = el('.form-editor-radio-button-group-renderer', [
      this.renderInput()
    ]);

  }

  renderInput() {

    this.input = list('div.group-input-options-container', Option);

    return this.input;

  }

  update(inputOptions, fieldRow) {

    this.input.update(inputOptions.options, fieldRow);

  }

}

export default RadioButtonGroupRenderer;